<template>
  <div class="agency_recommd container">
    <div class="container-head">
      <div class="head-left">
        <div class="icon">
          <img :src="datainfo.icon" />
        </div>
        {{ datainfo.title }}
      </div>
    </div>
    <div class="gif_img">
      <img
        :src="datainfo.pagevalue"
        class="hidden-lg hidden-md"
        mode="widthFix"
      />
      <img
        :src="datainfo.pagevaluepc"
        class="hidden-xs hidden-sm"
        mode="widthFix"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ["datainfo"]
};
</script>

<style lang="less" scoped>
.agency_recommd {
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicimg.vue